export enum BookNowPayLaterType {
    Klarna = 'Klarna',
    LeaBank = 'LeaBank',
}

export interface BookNowPayLaterStep {
    step: number;
    label: string;
}
